
var page = 1;
$(".load-more").click(function() {
    page++;
    loadMoreData(page);
});
function loadMoreData(page){
    var param = window.location.search;
    var search = param.replace("?", "&");
    $.ajax(
        {
            url: '?page=' + page +  search,
            type: "get",
            beforeSend: function()
            {
                $('body').loading('toggle');
            }
        })
        .done(function(data)
        {
            if(data.html == " "){
                $('.ajax-load').html("No more records found");
                return;
            }
            $('body').loading('toggle');
            $("#load_data").append(data.html);
        })
        .fail(function(jqXHR, ajaxOptions, thrownError)
        {
            alert('server not responding...');
        });
}
